(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-catalog-refine')) {
  customElements.define('tt-catalog-refine', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const drawer = this.querySelector('.tt-catalog__drawer');
      const opener = this.querySelector('[data-tt-open]');
      const close = () => { if (drawer?.open) drawer.close(); };
      opener?.addEventListener('click', () => {
        drawer.showModal();
        opener.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelectorAll('[data-tt-close]').forEach(button => button.addEventListener('click', close, options));
      drawer?.addEventListener('close', () => opener?.setAttribute('aria-expanded', 'false'), options);
      drawer?.addEventListener('click', event => {
        if (event.target !== drawer) return;
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }, options);
      matchMedia('(min-width: 960px)').addEventListener('change', event => { if (event.matches) close(); }, options);
      const popovers = [...this.querySelectorAll('.tt-catalog__desktop-filters details')];
      popovers.forEach(popover => popover.addEventListener('toggle', () => {
        if (popover.open) popovers.forEach(other => { if (other !== popover) other.open = false; });
      }, options));
      document.addEventListener('click', event => { popovers.forEach(popover => { if (!popover.contains(event.target)) popover.open = false; }); }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        popovers.forEach(popover => { if (popover.open) { popover.open = false; popover.querySelector('summary')?.focus(); } });
      }, options);
      const sort = this.querySelector('[data-tt-sort]');
      const applySort = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      };
      sort?.addEventListener('change', applySort, options);
      sort?.form?.addEventListener('submit', event => { event.preventDefault(); applySort(); }, options);
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() { this.querySelector('.tt-catalog__drawer')?.close(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-shop-carousel')) {
  customElements.define('tt-shop-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('[data-carousel-track]');
      const previous = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (!track || !previous || !next) return;
      this.setAttribute('data-enhanced', '');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('.tt-shop-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      requestAnimationFrame(update);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-giftcard-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tt-gift-product')){customElements.define('tt-gift-product',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const radios=this.querySelectorAll('input[name="id"]');const update=()=>{const active=this.querySelector('input[name="id"]:checked');if(!active)return;this.querySelectorAll('[data-gift-price],[data-gift-amount]').forEach(el=>el.textContent=active.dataset.price);const url=new URL(window.location.href);if(url.pathname.includes('/products/')){url.searchParams.set('variant',active.value);history.replaceState(null,'',url.toString());}};radios.forEach(input=>input.addEventListener('change',update));const recipient=this.querySelector('.tt-gift__recipient');const toggle=this.querySelector('[data-recipient-toggle]');const fields=this.querySelector('[data-recipient-fields]');const email=this.querySelector('[data-recipient-email]');if(recipient&&toggle&&fields&&email){recipient.hidden=false;const sync=()=>{fields.hidden=!toggle.checked;fields.disabled=!toggle.checked;email.required=toggle.checked;toggle.setAttribute('aria-expanded',String(toggle.checked));};toggle.addEventListener('change',sync);sync();}update();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-header"]) return;
  try {
    
if (!customElements.get('tt-site-header')) {
  customElements.define('tt-site-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const toggle = this.querySelector('.tt-mobile-toggle');
      const drawer = this.querySelector('.tt-drawer');
      if (!toggle || !drawer) return;
      const close = () => { if (drawer.open) drawer.close(); };
      toggle.addEventListener('click', () => {
        if (drawer.open) close();
        else { drawer.showModal(); toggle.setAttribute('aria-expanded', 'true'); }
      }, options);
      drawer.querySelector('.tt-drawer__close').addEventListener('click', close, options);
      drawer.addEventListener('close', () => { toggle.setAttribute('aria-expanded', 'false'); }, options);
      drawer.addEventListener('click', event => {
        if (event.target.closest('a')) close();
        if (event.target === drawer) {
          const bounds = drawer.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }
      }, options);
      const desktop = matchMedia('(min-width: 761px)');
      desktop.addEventListener('change', event => { if (event.matches) close(); }, options);
    }
    disconnectedCallback() { this.querySelector('.tt-drawer')?.close(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-limited-hoodie"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('madde-hoodie')) {
    customElements.define('madde-hoodie', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.querySelector('form');
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.mainButton = this.form.querySelector('[type="submit"]');
        this.sticky = this.querySelector('.madde-product__sticky');
        this.stickyButton = this.querySelector('[data-sticky-buy]');
        this.error = this.querySelector('[role="alert"]');
        this.dialog = this.querySelector('dialog');
        this.form.addEventListener('submit', event => this.add(event), {signal});
        this.form.addEventListener('change', event => {
          if (event.target.name === 'properties[Trykkfarge]') this.showChoiceImage(event.target.value);
          this.normalizeQuantity();this.error.hidden = true;this.sync();
        }, {signal});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.galleryIndex), {signal}));
        const media = this.querySelector('.madde-product__media');
        media.addEventListener('touchstart', event => {
          if (!event.target.closest('[data-photo]') || event.touches.length !== 1) return;
          this.touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY};
        }, {signal,passive:true});
        media.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          const count = this.querySelectorAll('[data-photo]').length;
          if (count > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            const current = Number(this.querySelector('[data-photo]:not([hidden])').dataset.photo);
            this.showImage((current + (dx < 0 ? 1 : -1) + count) % count);
          }
        }, {signal,passive:true});
        this.quantity.addEventListener('input', () => {if(this.quantity.value !== '') this.normalizeQuantity();this.sync();}, {signal});
        this.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
          this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, (Number(this.quantity.value) || 1) + Number(button.dataset.quantity)));
          this.sync();
        }, {signal}));
        this.stickyButton.addEventListener('click', () => {
          if (!this.validateChoices()) return;
          this.form.requestSubmit();
        }, {signal});
        this.querySelector('[data-zoom-open]')?.addEventListener('click', () => this.dialog.showModal(), {signal});
        this.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog?.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.15});
        this.observer.observe(this.mainButton);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
      showChoiceImage(choice) {
        const button = Array.from(this.querySelectorAll('[data-gallery-index]')).find(item => item.dataset.imageChoice === choice);
        if (button) this.showImage(button.dataset.galleryIndex);
      }
      showImage(index) {
        const active = Array.from(this.querySelectorAll('[data-photo]')).find(photo => photo.dataset.photo === String(index));
        if (!active) return;
        this.querySelectorAll('[data-photo]').forEach(photo => {photo.hidden = photo !== active;});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryIndex === String(index))));
        this.querySelectorAll('[data-zoom-photo]').forEach(photo => {photo.hidden = photo.dataset.zoomPhoto !== String(index);});
        const caption = this.querySelector('[data-image-caption]');
        if (caption) caption.textContent = active.querySelector('img')?.alt || '';
      }
      selection(group) {
        return this.querySelector('[data-' + group + '-group] input:checked');
      }
      normalizeQuantity() {
        this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, Math.trunc(Number(this.quantity.value) || 1)));
      }
      sync() {
        const size = this.selection('size');
        const print = this.selection('print');
        const amount = Number(this.quantity.value) || 1;
        this.querySelector('[data-quantity="-1"]').disabled = amount <= 1 || this.busy;
        this.querySelector('[data-quantity="1"]').disabled = amount >= Number(this.quantity.max) || this.busy;
        this.querySelector('[data-selection]').textContent = [size?.value, print?.value].filter(Boolean).join(' · ') || this.dataset.sizeLabel;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nb-NO', {style:'currency',currency:this.dataset.currency || 'NOK'}).format(Number(this.dataset.price) * amount / 100);
        if (Number(this.dataset.stock) > 0) {
          this.stickyButton.textContent = this.busy ? this.dataset.busyLabel : !size ? this.dataset.sizeLabel : !print ? this.dataset.printLabel : this.dataset.addLabel;
          this.mainButton.querySelector('span').textContent = this.busy ? this.dataset.busyLabel : this.dataset.addLabel;
          this.mainButton.disabled = !!this.busy;
          this.stickyButton.disabled = !!this.busy;
        }
      }
      validateChoices() {
        for (const group of ['size','print']) {
          if (!this.selection(group)) {
            this.error.textContent = this.dataset[group + 'Error'];
            this.error.hidden = false;
            const fieldset = this.querySelector('[data-' + group + '-group]');
            fieldset.scrollIntoView({block:'center',behavior:'instant'});
            fieldset.querySelector('input').focus({preventScroll:true});
            return false;
          }
        }
        return this.form.reportValidity();
      }
      async add(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy || Number(this.dataset.stock) < 1 || !this.validateChoices()) return;
        const data = new FormData(this.form);
        this.busy = true;
        this.error.hidden = true;
        this.sync();
        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          const alreadyInCart = cart.items.reduce((sum,line) => sum + (String(line.variant_id) === String(data.get('id')) ? line.quantity : 0), 0);
          if (alreadyInCart + Number(data.get('quantity')) > Number(this.dataset.stock)) throw new Error(this.dataset.limitError);
          const response = await fetch(this.dataset.addUrl, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          this.error.textContent = failure.message || this.dataset.error;
          this.error.hidden = false;
          this.error.scrollIntoView({block:'center',behavior:'instant'});
          this.busy = false;
          this.sync();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-limited-motala"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('madde-motala')) {
    customElements.define('madde-motala', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.querySelector('form');
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.mainButton = this.form.querySelector('[type="submit"]');
        this.sticky = this.querySelector('.madde-product__sticky');
        this.stickyButton = this.querySelector('[data-sticky-buy]');
        this.error = this.querySelector('[role="alert"]');
        this.dialog = this.querySelector('dialog');
        this.form.addEventListener('submit', event => this.add(event), {signal});
        this.form.addEventListener('change', event => {
          if (event.target.name === 'properties[Selefarge]') {
            this.selectColor(event.target);
            this.showChoiceImage(event.target.value);
          }
          this.normalizeQuantity();this.error.hidden = true;this.sync();
        }, {signal});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.galleryIndex), {signal}));
        const media = this.querySelector('.madde-product__media');
        media.addEventListener('touchstart', event => {
          if (!event.target.closest('[data-photo]') || event.touches.length !== 1) return;
          this.touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY};
        }, {signal,passive:true});
        media.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          const count = this.querySelectorAll('[data-photo]').length;
          if (count > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            const current = Number(this.querySelector('[data-photo]:not([hidden])').dataset.photo);
            this.showImage((current + (dx < 0 ? 1 : -1) + count) % count);
          }
        }, {signal,passive:true});
        this.quantity.addEventListener('input', () => {if(this.quantity.value !== '') this.normalizeQuantity();this.sync();}, {signal});
        this.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
          this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, (Number(this.quantity.value) || 1) + Number(button.dataset.quantity)));
          this.sync();
        }, {signal}));
        this.stickyButton.addEventListener('click', () => {
          if (!this.validateChoices()) return;
          this.form.requestSubmit();
        }, {signal});
        this.querySelector('[data-zoom-open]')?.addEventListener('click', () => this.dialog.showModal(), {signal});
        this.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog?.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.15});
        this.observer.observe(this.mainButton);
        const selectedColor = this.selection('color');
        if (selectedColor) this.selectColor(selectedColor);
        this.normalizeQuantity();
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
      selectColor(color) {
        this.form.querySelector('[name="id"]').value = color.dataset.variantId;
        this.dataset.stock = color.dataset.stock;
        this.dataset.price = color.dataset.price;
        this.quantity.max = String(Math.max(1, Number(color.dataset.stock) || 0));
      }
      showChoiceImage(choice) {
        const button = Array.from(this.querySelectorAll('[data-gallery-index]')).find(item => item.dataset.imageChoice === choice);
        if (button) this.showImage(button.dataset.galleryIndex);
      }
      showImage(index) {
        const active = Array.from(this.querySelectorAll('[data-photo]')).find(photo => photo.dataset.photo === String(index));
        if (!active) return;
        this.querySelectorAll('[data-photo]').forEach(photo => {photo.hidden = photo !== active;});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryIndex === String(index))));
        this.querySelectorAll('[data-zoom-photo]').forEach(photo => {photo.hidden = photo.dataset.zoomPhoto !== String(index);});
        const caption = this.querySelector('[data-image-caption]');
        if (caption) caption.textContent = active.querySelector('img')?.alt || '';
      }
      selection(group) {
        return this.querySelector('[data-' + group + '-group] input:checked');
      }
      normalizeQuantity() {
        this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, Math.trunc(Number(this.quantity.value) || 1)));
      }
      sync() {
        const color = this.selection('color');
        const print = this.selection('print');
        const amount = Number(this.quantity.value) || 1;
        this.querySelector('[data-quantity="-1"]').disabled = amount <= 1 || this.busy;
        this.querySelector('[data-quantity="1"]').disabled = amount >= Number(this.quantity.max) || this.busy;
        this.querySelector('[data-selection]').textContent = [color?.value, print?.value].filter(Boolean).join(' · ') || this.dataset.colorLabel;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nb-NO', {style:'currency',currency:this.dataset.currency || 'NOK'}).format(Number(this.dataset.price) * amount / 100);
        if (Number(this.dataset.stock) > 0) {
          this.stickyButton.textContent = this.busy ? this.dataset.busyLabel : !color ? this.dataset.colorLabel : !print ? this.dataset.printLabel : this.dataset.addLabel;
          this.mainButton.querySelector('span').textContent = this.busy ? this.dataset.busyLabel : this.dataset.addLabel;
          this.mainButton.disabled = !!this.busy;
          this.stickyButton.disabled = !!this.busy;
        } else {
          this.mainButton.disabled = true;
          this.stickyButton.disabled = true;
          this.mainButton.querySelector('span').textContent = this.dataset.soldOutLabel;
          this.stickyButton.textContent = this.dataset.soldOutLabel;
        }
      }
      validateChoices() {
        for (const group of ['color','print']) {
          if (!this.selection(group) || this.selection(group).disabled) {
            this.error.textContent = this.dataset[group + 'Error'];
            this.error.hidden = false;
            const fieldset = this.querySelector('[data-' + group + '-group]');
            fieldset.scrollIntoView({block:'center',behavior:'instant'});
            fieldset.querySelector('input:not(:disabled)')?.focus({preventScroll:true});
            return false;
          }
        }
        return this.form.reportValidity();
      }
      async add(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy || Number(this.dataset.stock) < 1 || !this.validateChoices()) return;
        const data = new FormData(this.form);
        this.busy = true;
        this.error.hidden = true;
        this.sync();
        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          const alreadyInCart = cart.items.reduce((sum,line) => sum + (String(line.variant_id) === String(data.get('id')) ? line.quantity : 0), 0);
          if (alreadyInCart + Number(data.get('quantity')) > Number(this.dataset.stock)) throw new Error(this.dataset.limitError);
          const response = await fetch(this.dataset.addUrl, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          this.error.textContent = failure.message || this.dataset.error;
          this.error.hidden = false;
          this.error.scrollIntoView({block:'center',behavior:'instant'});
          this.busy = false;
          this.sync();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-limited-tote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('madde-tote')) {
    customElements.define('madde-tote', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.querySelector('form');
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.mainButton = this.form.querySelector('[type="submit"]');
        this.sticky = this.querySelector('.madde-product__sticky');
        this.stickyButton = this.querySelector('[data-sticky-buy]');
        this.error = this.querySelector('[role="alert"]');
        this.dialog = this.querySelector('dialog');
        this.form.addEventListener('submit', event => this.add(event), {signal});
        this.form.addEventListener('change', event => {
          if (event.target.name === 'properties[Trykkfarge]') this.showChoiceImage(event.target.value);
          this.normalizeQuantity();this.error.hidden = true;this.sync();
        }, {signal});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.galleryIndex), {signal}));
        const media = this.querySelector('.madde-product__media');
        media.addEventListener('touchstart', event => {
          if (!event.target.closest('[data-photo]') || event.touches.length !== 1) return;
          this.touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY};
        }, {signal,passive:true});
        media.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          const count = this.querySelectorAll('[data-photo]').length;
          if (count > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            const current = Number(this.querySelector('[data-photo]:not([hidden])').dataset.photo);
            this.showImage((current + (dx < 0 ? 1 : -1) + count) % count);
          }
        }, {signal,passive:true});
        this.quantity.addEventListener('input', () => {if(this.quantity.value !== '') this.normalizeQuantity();this.sync();}, {signal});
        this.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
          this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, (Number(this.quantity.value) || 1) + Number(button.dataset.quantity)));
          this.sync();
        }, {signal}));
        this.stickyButton.addEventListener('click', () => {
          if (!this.validateChoices()) return;
          this.form.requestSubmit();
        }, {signal});
        this.querySelector('[data-zoom-open]')?.addEventListener('click', () => this.dialog.showModal(), {signal});
        this.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog?.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.15});
        this.observer.observe(this.mainButton);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
      showChoiceImage(choice) {
        const button = Array.from(this.querySelectorAll('[data-gallery-index]')).find(item => item.dataset.imageChoice === choice);
        if (button) this.showImage(button.dataset.galleryIndex);
      }
      showImage(index) {
        const active = Array.from(this.querySelectorAll('[data-photo]')).find(photo => photo.dataset.photo === String(index));
        if (!active) return;
        this.querySelectorAll('[data-photo]').forEach(photo => {photo.hidden = photo !== active;});
        this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryIndex === String(index))));
        this.querySelectorAll('[data-zoom-photo]').forEach(photo => {photo.hidden = photo.dataset.zoomPhoto !== String(index);});
        const caption = this.querySelector('[data-image-caption]');
        if (caption) caption.textContent = active.querySelector('img')?.alt || '';
      }
      selection(group) {
        return this.querySelector('[data-' + group + '-group] input:checked');
      }
      normalizeQuantity() {
        this.quantity.value = Math.min(Number(this.quantity.max), Math.max(1, Math.trunc(Number(this.quantity.value) || 1)));
      }
      sync() {
        const print = this.selection('print');
        const amount = Number(this.quantity.value) || 1;
        this.querySelector('[data-quantity="-1"]').disabled = amount <= 1 || this.busy;
        this.querySelector('[data-quantity="1"]').disabled = amount >= Number(this.quantity.max) || this.busy;
        this.querySelector('[data-selection]').textContent = print?.value || this.dataset.printLabel;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nb-NO', {style:'currency',currency:this.dataset.currency || 'NOK'}).format(Number(this.dataset.price) * amount / 100);
        if (Number(this.dataset.stock) > 0) {
          this.stickyButton.textContent = this.busy ? this.dataset.busyLabel : !print ? this.dataset.printLabel : this.dataset.addLabel;
          this.mainButton.querySelector('span').textContent = this.busy ? this.dataset.busyLabel : this.dataset.addLabel;
          this.mainButton.disabled = !!this.busy;
          this.stickyButton.disabled = !!this.busy;
        }
      }
      validateChoices() {
        for (const group of ['print']) {
          if (!this.selection(group)) {
            this.error.textContent = this.dataset[group + 'Error'];
            this.error.hidden = false;
            const fieldset = this.querySelector('[data-' + group + '-group]');
            fieldset.scrollIntoView({block:'center',behavior:'instant'});
            fieldset.querySelector('input').focus({preventScroll:true});
            return false;
          }
        }
        return this.form.reportValidity();
      }
      async add(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy || Number(this.dataset.stock) < 1 || !this.validateChoices()) return;
        const data = new FormData(this.form);
        this.busy = true;
        this.error.hidden = true;
        this.sync();
        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          const alreadyInCart = cart.items.reduce((sum,line) => sum + (String(line.variant_id) === String(data.get('id')) ? line.quantity : 0), 0);
          if (alreadyInCart + Number(data.get('quantity')) > Number(this.dataset.stock)) throw new Error(this.dataset.limitError);
          const response = await fetch(this.dataset.addUrl, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          this.error.textContent = failure.message || this.dataset.error;
          this.error.hidden = false;
          this.error.scrollIntoView({block:'center',behavior:'instant'});
          this.busy = false;
          this.sync();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
